<div (clickOutside)="close()">
    <m-search-input (clear)="onClear()" [isFocus]="true"
                    (keyPress)="onSearch($event)" value="{{data.searchText}}"
                    tooltip="{{'GENERAL.TOOLTIP_MSG' | translate}}"></m-search-input>
</div>
